import { type ComponentProps } from "react";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const panelTitleVariants = cva(
  `
    m-0 mb-1 text-(length:--console-type-panel-title) font-bold
    text-(--console-foreground)
  `,
);

export const PanelTitle = ({
  className,
  ref,
  ...props
}: ComponentProps<"h3">) => (
  <h3 ref={ref} className={cn(panelTitleVariants(), className)} {...props} />
);

export { panelTitleVariants };
